// CourseContext.tsx
import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import type {IContact} from '../interfaces/IContact';
import type {ICourse} from '../interfaces/ICourse';
// import axios from 'axios';
import axiosInstance from "../helpers/Axios";

interface ICourseObj {
    course: ICourse;
    subscribes: IContact[];
    nbSubscribes: number;
}

interface CourseContextType {
    list: ICourseObj[];
    loading: boolean;
}

const defaultList: ICourseObj[] = [];

const CourseContext = createContext<CourseContextType | undefined>(undefined);

interface CourseProviderProps { children: ReactNode; }

export const CourseProvider = ({ children }: CourseProviderProps) => {
    const [list, setList] = useState(defaultList);
//   const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(true);
    const loading = list === defaultList && visible;

//   useEffect(() => {
//     axios.get('/course')
//       .then(res => setList(res.data))
//       .finally(() => setLoading(false));
//   }, []);

    useEffect(() => {
        // console.log("Fetching /course");
        if (loading)
            axiosInstance.get("/course")
                .then(response => {
                    
                    // console.log('response', response);

                    setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
                    // setUserProfile(response.data);
                    // setLocation(response.data.location);
                })
                .catch((err) => {
                    const error = err.response === undefined ?
                        'Server in not reachable'
                        : err.response.data;
                    console.log('error', error);
                    setVisible(false);
                });
    }, []);

  return (
    <CourseContext.Provider value={{ list, loading }}>
      {children}
    </CourseContext.Provider>
  );
};

export const useCourses = () => { 
    const context = useContext(CourseContext); 
    if (!context) 
        throw new Error("useCourses must be used within a CourseProvider"); 
    return context; 
};
// End of CourseContext.tsx